<script>

import Service from '../../../services/equipment-operation';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '../../generic/GenericCustomMasterDataAutocompleteV2.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
        GenericCustomMasterDataAutocompleteV2
    },
    validations(){
        return {
            data: {
                tankCode: {required},
                calculationDate: {required}
            }
        }
    },
    data(){
        return {
            submitted: false,
            detailsDialogVisible: false,
            samplingNumbers: [],
            dialog: {
                params: {
                    samplingNumber: null
                }
            },
            data: {
                
            },
            params: {
                pageType: 'Discarica',
                sampleNumber: null,
                samplingPoint: null,
                measureDate: null
            },
            types: [
                {
                    value: 'Discarica',
                },
                {
                    value: 'Doganale'
                }
            ],
            dischargeTanks: ['S BAR','N BAR']
        }
    },
    methods: {
        onPageTypeChange(){
            this.params.samplingPoint = null;
        },
        loadData(){
            let params = {
                pageType: this.params.pageType,
                sampleNumber: this.params.sampleNumber,
                samplingPoint: this.params.samplingPoint,
                measureDate: this.params.measureDate ? Utils.formatDateForAPI(this.params.measureDate) : null
            }
            this.data = {};
            this.samplingNumbers = [];
            this.dialog.params.samplingNumber = null;
            this.$store.dispatch("generic/setLoading", true);

            Service.getLimsAdvancedSearch(
                params, 
                ({success, message, data}) => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(success){
                        if(data.moreThanOneSampleFound){
                            this.detailsDialogVisible = true;
                            Service.getLimsAdvancedSearchCompleteList(
                                params,
                                ({success, message, data}) => {
                                    if(success){
                                        this.samplingNumbers = [...data]
                                    }else{
                                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    }
                                }
                            )

                        }else{
                            this.data = {...data.measures}
                            this.data.dataPrelievo = Utils.formatDateTime(new Date(this.data.dataPrelievo))
                        }
                    }else{
                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        selectedPageType(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.pageType : null
        },
        selectedSamplingPoint(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.samplingPoint : null
        },
        selectedProduct(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.product : null
        },
        selectedSamplingDate(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData && this.dialog.params.samplingNumber.extraData.samplingDate ? Utils.formatDateTime(new Date(this.dialog.params.samplingNumber.extraData.samplingDate)) : null
        },
        selectedVoyageNumber(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.voyageNumber : null
        },
        selectedVessel(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.vessel : null
        },
        selectedAnalysisList(){
            return this.dialog.params.samplingNumber && this.dialog.params.samplingNumber.extraData ? this.dialog.params.samplingNumber.extraData.analysisList : []
        }
    },  
}
</script>

<template>
    <Dialog v-model:visible="detailsDialogVisible" modal closable :style="{width: '85vw'}" >
        <div class="grid" >
            <div class="col-12 field">
                <label>{{$t('limsInterface.sampleNumber')}}</label>
                <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="dialog.params.samplingNumber" :options="samplingNumbers" optionLabel="label" />
            </div>
        </div>
        <div class="grid" >
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.type')}}</label>
                <InputText type="text" readonly v-model="selectedPageType" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.puntoPrelievo')}}</label>
                <InputText type="text" readonly v-model="selectedSamplingPoint" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.prodotto')}}</label>
                <InputText type="text" readonly v-model="selectedProduct" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.dataPrelievo')}}</label>
                <InputText type="text" readonly v-model="selectedSamplingDate" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.viaggio')}}</label>
                <InputText type="text" readonly v-model="selectedVoyageNumber" :class="{'w-full p-inputtext-sm': true}" />
            </div>
            <div class="col-12 lg:col-6 field">
                <label>{{$t('limsInterface.nave')}}</label>
                <InputText type="text" readonly v-model="selectedVessel" :class="{'w-full p-inputtext-sm': true}" />
            </div>
        </div>
        <div class="grid">
            <div class="col-12">
                <DataTable :value="selectedAnalysisList" tableStyle="width: 100%" scrollable scrollHeight="400px">
                    <Column field="analysisCode" :header="$t('limsInterface.analysisCode')" />
                    <Column field="analysisDescription" :header="$t('limsInterface.analysisDescription')" />
                    <Column field="analysisMethod" :header="$t('limsInterface.analysisMethod')" />
                    <Column field="measureUnit" :header="$t('limsInterface.measureUnit')" />
                    <Column field="analysisValue" :header="$t('limsInterface.analysisValue')" />
                </DataTable>
            </div>
        </div>
    </Dialog>
    <div class="grid" >
        <div class="col-12 lg:col-3">
            <Card>
                <template #content>
                    <div class="grid formgrid" >
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.type')}}</label>
                            <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="params.pageType" :options="types" optionValue="value" @change="onPageTypeChange">
                                <template #value="slotProps">
                                <div v-if="slotProps.value == 'Discarica'">
                                    <span>{{$t('limsInterface.dischargeType')}}</span>
                                </div>
                                <div v-else-if="slotProps.value == 'Doganale'">
                                    <span>{{$t('limsInterface.customsType')}}</span>
                                </div>
                                <div v-else>
                                    <span class="p-dropdown-label">{{slotProps.value}}</span>
                                </div>
                            </template>
                                <template #option="slotProps">
                                    <div v-if="slotProps.option.value == 'Discarica'">
                                        <span>{{$t('limsInterface.dischargeType')}}</span>
                                    </div>
                                    <div v-else-if="slotProps.option.value == 'Doganale'">
                                        <span>{{$t('limsInterface.customsType')}}</span>
                                    </div>
                                </template>
                            </Dropdown>
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.sampleNumber')}}</label>
                            <InputText type="text" v-model="params.sampleNumber" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 field" v-if="params.pageType == 'Discarica'">
                            <label>{{$t('limsInterface.tank')}}</label>
                            <Dropdown class="w-full p-inputtext-sm" :placeholder="null" v-model="params.samplingPoint" :options="dischargeTanks" />
                        </div>
                        <div class="col-12 field" v-if="params.pageType == 'Doganale'">
                            <label>{{$t('calculatorInsertData.container')}}</label>
                            <GenericCustomMasterDataAutocompleteV2
                                class="w-full p-inputtext-sm"
                                v-model="params.samplingPoint"
                                name="tank-management-tank-combo"
                                :format="{ label: 'code', value: 'code' }"
                                api="tank-management/tank-combo" />  
                        </div> 
                        <div class="col-12 field">
                            <label>{{$t('calculatorInsertData.date_hour')}}</label>
                            <Calendar 
                                v-model="params.measureDate"
                                :dateFormat="constants.DATE_FORMAT_POINT"
                                :showTime="false"
                                :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                                class="w-full p-inputtext-sm " />
                        </div>
                    </div>
                </template>
                <template #footer>
                    <Button :label="$t('calculatorTankDevelopment.btnLimsLoad')" icon="pi pi-upload" class="m-2 p-button-sm" @click="loadData" :disabled="!uiPermissions('tankCalculatorLimsButton').isEnabled" />
                </template>
            </Card>
        </div>
        <div class="col-12 lg:col-6">
            <Card>
                <template #content>
                    <div class="grid formgrid" >
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.sampleNumber')}}</label>
                            <InputText type="text" readonly v-model="data.numeroCampione" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.densita15')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="4" :maxFractionDigits="4" type="text" readonly v-model="data.densita15Valore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.densita15UnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.type')}}</label>
                            <InputText type="text" readonly v-model="data.tipologia" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.pesoMolecolare')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.pesoMolecolareValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.pesoMolecolareUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.puntoPrelievo')}}</label>
                            <InputText type="text" readonly v-model="data.puntoPrelievo" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcqua')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.contenutoAcquaValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.contenutoAcquaUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.prodotto')}}</label>
                            <InputText type="text" readonly v-model="data.prodotto" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.sedimentiPerEstrazione')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.sedimentiPerEstrazioneValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.sedimentiPerEstrazioneUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.dataPrelievo')}}</label>
                            <InputText type="text" readonly v-model="data.dataPrelievo" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoAcquaSedimenti')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.contenutoAcquaSedimentiValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.contenutoAcquaSedimentiUnitaMisura}}</span>
                            </div>
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.viaggio')}}</label>
                            <InputText type="text" readonly v-model="data.viaggio" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.gradoApi')}}</label>
                            <InputText :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.gradoApiValore" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.nave')}}</label>
                            <InputText type="text" readonly v-model="data.nave" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 lg:col-6 field">
                            <label>{{$t('limsInterface.contenutoZolfo')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputText :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.contenutoZolfoValore" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">{{data.contenutoZolfoUnitaMisura}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
        <div class="col-12 lg:col-3">
            <Card>
                <template #content>
                    <div class="grid formgrid" >
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.densita15')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="4" :maxFractionDigits="4" type="text" readonly v-model="data.densita15" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">Kg/Lt</span>
                            </div>
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.pesoMolecolare')}}</label>
                            <InputNumber :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.pesoMolecolare" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.contenutoAcqua')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.percentualeVolumeAcqua" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.sedimentiPerEstrazione')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.percentualeVolumeSedimenti" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.contenutoAcquaSedimenti')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="3" :maxFractionDigits="3" type="text" readonly v-model="data.percentualeVolumeAcquaSedimenti" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% vol</span>
                            </div>
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.gradoApi')}}</label>
                            <InputNumber :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.gradoApi" :class="{'w-full p-inputtext-sm': true}" />
                        </div>
                        <div class="col-12 field">
                            <label>{{$t('limsInterface.contenutoZolfo')}}</label>
                            <div class="p-inputgroup w-full">
                                <InputNumber :minFractionDigits="2" :maxFractionDigits="2" type="text" readonly v-model="data.percentualePesoZolfo" :class="{'w-full p-inputtext-sm': true}" />
                                <span class="p-inputgroup-addon" style="width: 30%">% wt</span>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
    </div>
</template>